<template>
  <svg xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 24 24">
    <path
      d="M2,19v-2h10v2H2ZM2,14v-2h5v2H2ZM2,9v-2h5v2H2ZM20.6,19l-3.9-3.9c-.4.3-.8.5-1.3.6-.5.1-1,.2-1.4.2-1.4,0-2.6-.5-3.5-1.5-1-1-1.5-2.2-1.5-3.5s.5-2.6,1.5-3.5c1-1,2.2-1.5,3.5-1.5s2.6.5,3.5,1.5,1.5,2.2,1.5,3.5,0,1-.2,1.4c-.1.5-.4.9-.6,1.3l3.9,3.9-1.4,1.4ZM14,14c.8,0,1.5-.3,2.1-.9s.9-1.3.9-2.1-.3-1.5-.9-2.1-1.3-.9-2.1-.9-1.5.3-2.1.9-.9,1.3-.9,2.1.3,1.5.9,2.1,1.3.9,2.1.9Z"
    />
  </svg>
</template>
